// This file was automatically generated from uiwidget.PagedTabbedNav.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.PagedTabbedNav');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.PagedTabbedNav.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="paged-tab-container">');
  el8.template.uiwidget.PagedTabbedNav.tabPage(soy.$$augmentData(opt_data, {index: 0}), output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.PagedTabbedNav.tabPage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="', soy.$$escapeHtml(opt_data.tabSectionClass), ' tab-page" data-index="', soy.$$escapeHtml(opt_data.index), '" style="display: none">', (opt_data.index > 0) ? '<div class="el8InlineBlock prev-btn-container"><li class="' + soy.$$escapeHtml(opt_data.tabItemClass) + '"><a class="change-page-trigger" data-new-index="' + soy.$$escapeHtml(opt_data.index - 1) + '">&lt;&lt;</a></li></div>' : '', '<div class="el8InlineBlock tab-list"></div><div class="el8InlineBlock fr next-btn-container" style="display: none"><li class="', soy.$$escapeHtml(opt_data.tabItemClass), '"><a class="change-page-trigger" data-new-index="', soy.$$escapeHtml(opt_data.index + 1), '">&gt;&gt;</a></li></div></div>');
  if (!opt_sb) return output.toString();
};
